var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from "react";
import PropTypes from "prop-types";
import { Broadcast } from "react-broadcast";

var Stack = function (_Component) {
  _inherits(Stack, _Component);

  function Stack() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Stack);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Stack.__proto__ || Object.getPrototypeOf(Stack)).call.apply(_ref, [this].concat(args))), _this), _this.state = { index: _this.props.startAt }, _this.reducer = {
      goForward: function goForward() {
        return function (_ref2) {
          var index = _ref2.index;
          return { index: index + 1 };
        };
      },
      goBack: function goBack() {
        return function (_ref3) {
          var index = _ref3.index;
          return { index: Math.max(0, index - 1) };
        };
      },
      jumpTo: function jumpTo(index) {
        return { index: index };
      }
    }, _this.dispatch = function (type, payload) {
      if (!_this.reducer[type]) return _this.setState({});
      _this.setState(_this.reducer[type](payload));
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Stack, [{
    key: "render",
    value: function render() {
      var dispatch = this.dispatch;
      var _props = this.props,
          stack = _props.stack,
          children = _props.children;
      var index = this.state.index;

      return React.createElement(
        Broadcast,
        { value: { dispatch: dispatch, index: index }, channel: stack },
        React.createElement(
          "div",
          null,
          children
        )
      );
    }
  }]);

  return Stack;
}(Component);

Stack.defaultProps = {
  stack: "slides",
  startAt: 0
};

Stack.propTypes = {
  stack: PropTypes.string,
  startAt: PropTypes.number,
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)])
};

export default Stack;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-framestack/lib/Stack.js
// module id = 38
// module chunks = 0